/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
// Extends From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import moment from 'moment';
// Internal Imports
import Reason from 'linced-app/enums/medical/reason';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { action } from '@ember/object';
import { rollbackRecord } from '@linc-technologies/linced-common/utils/record-rollback';

export default class BatchEntry extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  Reason = Reason;
  Jurisdiction = Jurisdiction;
  @tracked
  batch = null;
  @tracked
  dialogOpen = false;
  edit = false;
  medication = null;

  @tracked
  saveInProgress;

  @action
  openDialog() {
    if (this.edit) {
      this.dialogOpen = true;
    } else {
      this.batch = this.store.createRecord('medical/batch', {
        schoolId: this.get('session.school'),
      });

      this.dialogOpen = true;
    }
  }

  @action
  closeDialog() {
    if (!this.batch.get('id')) {
      this.batch.deleteRecord();
      this.batch = null;
    } else {
      // Restore any altered attributes and relationships.
      rollbackRecord(this.batch);
    }
    this.dialogOpen = false;
  }

  @action
  save() {
    this.saveInProgress = true;
    this.batch.set('medication', this.medication);
    return this.batch
      .save()
      .then(() => {
        this.toaster.success('Batch saved successfully!');
        this.dialogOpen = false;
      })
      .catch(() => {
        // Stay open to retry; closeDialog discards the unsaved batch.
        this.toaster.error('Batch save failed!');
      })
      .finally(() => {
        this.saveInProgress = false;
      });
  }

  @action
  setBatchDate(type, date) {
    if (isEmpty(date)) {
      this.batch.set(type, undefined);
      return;
    }
    this.batch.set(type, moment(date, 'YYYY-MM-DD').unix());
    if (type === 'expiryDate' && isEmpty(this.batch.get('reviewDate'))) {
      // Set a default for review date if it is empty
      let today = moment();
      let expiryDate = moment(date, 'YYYY-MM-DD');
      // Set the review date to 1 week before the expiry date
      let reviewDate = moment(date, 'YYYY-MM-DD').subtract(1, 'w');
      // Unless expiry date is less than one week away - then set review date to the expiry date
      if (expiryDate.diff(today, 'd') < 7) {
        reviewDate = expiryDate;
      }
      this.batch.set('reviewDate', reviewDate.unix());
    }
  }
}
